import { render } from "./TemplateRolePreview.vue?vue&type=template&id=82ab3520"
import script from "./TemplateRolePreview.vue?vue&type=script&lang=js"
export * from "./TemplateRolePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__